<div>
  <form [formGroup]="form" novalidate="off">
    <div *ngFor="let formControl of listOfFormElements" class="form-row">
      <ng-container *ngIf="formControl.type !== 'multiple-dropdown'">
        <app-dynamic-control [outputValue]="Valuesoutput" [formElement]="formControl" [form]="form"
                             (valChange)="fieldValChange($event)"></app-dynamic-control>
      </ng-container>
      <mat-form-field appearance="outline" class="form-element" *ngIf="formControl.type === 'multiple-dropdown'">
        <mat-select #companySelect class="" [placeholder]="formControl.label" multiple
                    (openedChange)="closeCurrentCompany($event, formControl.key)" [(ngModel)]="Valuesoutput[formControl.key]"
                    [formControl]="companyCtrl" (selectionChange)="updateCurrentCompany($event.value, formControl.key)">
          <mat-option>
            <ngx-mat-select-search [formControl]="companyFilterCtrl"  [placeholderLabel]="'Search Recons'"
              [noEntriesFoundLabel]="'No matching recon found'" [searching]="searching"></ngx-mat-select-search>
          </mat-option>
          <!-- <mat-select-trigger> {{company && company.value ? company.value[0] : ''}}
            <span *ngIf="company && company.value?.length > 1" class="example-additional-selection">
              (+{{company.value?.length - 1}} {{company.value?.length === 2 ? 'other' : 'others'}})
            </span>
          </mat-select-trigger> -->
          <mat-option [matTooltip]="company.reconName" *ngFor="let company of filteredCompanies | async" [value]="company.reconId">
            {{company.reconName|ellipsis: 25 }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    
    <div class="form-row">
      <button type="submit" *ngIf="isSaveBtn" [disabled]="!form || !form.valid" class="mr-2" mat-raised-button color="primary"
              (click)="Save(form)">{{fnBtnName}}
      </button>
      <button type="submit" (click)="Cancel()" *ngIf="isCloseBtn" mat-raised-button>{{closeBtnName}}</button>
    </div>
  </form>
</div>
